/**
 * Calcule l'importance visuelle d'un composant.
 * Ce score combine taille, contraste et position pour ordonner
 * les elements lus rapidement par l'eleve.
 */
import { TGDComponent } from '../../../models/courses/graphicDesign';
import { contrastRatio } from './color';
import { sizeOf } from './selectors';

const clamp01 = (value: number): number => Math.max(0, Math.min(1, value));

/** Retourne le score de lecture rapide, avec direction du texte. */
export const salienceOf = (
  c: TGDComponent, background: string,
  artboard: { width: number; height: number }, direction?: 'ltr' | 'rtl'
): number => {
  const contrast = contrastRatio(c.fill, background) ?? 1;
  const contrastFactor = Math.min(contrast, 7) / 7;
  const cy = clamp01(artboard.height > 0 ? (c.y + c.height / 2) / artboard.height : 0);
  const cx = clamp01(artboard.width > 0 ? (c.x + c.width / 2) / artboard.width : 0);
  const startX = direction === 'rtl' ? 1 - cx : cx;
  const positionFactor = 1 + 0.2 * (1 - cy) + 0.05 * (1 - startX);
  return sizeOf(c) * contrastFactor * positionFactor;
};
